import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../../services/withRouter";
import { saveAs } from 'file-saver';


class OrganizationRegistrations extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getOrganizationRegistrations();
    };



    getOrganizationRegistrations = async()=>{
        var response = await Api.GetRequest({}, 'entrepreneurship-developement/organization-registrations');
        if(response.status == 200){
            this.setState({'organization_registrations' : response.organization_registrations});
        }
        else{
            toast.error("Something went wrong. Please try again later.");
        }
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'organization_registrations' : []
        };
    }




    showPortal = async(id)=>{
        this.props.navigate("/entrepreneurship-developement/organization-registration/"+id)
    }
    
   

    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000',"textTransform" : "uppercase"}}>Entity Registrations</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" class="section_padding">
                    <div class="container">
                        <div class="row" id="counter">
                            {this.state.organization_registrations.map((organization_registration)=>{
                                return(
                                    <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                                        <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                            <div class="case_boxed_img">
                                                <a href="javascript:;">
                                                    <img src={process.env.REACT_APP_SERVER + organization_registration.image} alt="img"/>
                                                </a>
                                            </div>
                                            <div class="causes_boxed_text">
                                                <h5 style={{'height' : '43px'}}>
                                                    <a style={{'color' : '#000000'}} href="javascript:;" onClick={()=>{this.showPortal(organization_registration.id)}}>{organization_registration.title}</a>
                                                </h5>
                                                <a href="javascript:;" onClick={()=>{this.showPortal(organization_registration.id)}}><button className="btn btn_theme btn_md mt-3 py-1">Click Here</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(OrganizationRegistrations)